import {useSyncExternalStore} from 'react'

// Kits generated in this session that the dashboard is waiting on, so the
// "kit ready" notice shows up even after leaving the Kit comercial section
// (see useAgencyKitNotifier), plus the kit to open when that notice is clicked.
type KitWatchState = { watchedIds: string[], openKitId: string | null }

let state: KitWatchState = {watchedIds: [], openKitId: null}
const listeners = new Set<() => void>()

const setState = (next: KitWatchState) => {
    state = next
    listeners.forEach(listener => listener())
}

const subscribe = (listener: () => void) => {
    listeners.add(listener)
    return () => { listeners.delete(listener) }
}

export const watchAgencyKit = (id: string) => {
    if (!state.watchedIds.includes(id)) setState({...state, watchedIds: [...state.watchedIds, id]})
}

export const unwatchAgencyKit = (id: string) => {
    if (state.watchedIds.includes(id)) setState({...state, watchedIds: state.watchedIds.filter(watched => watched !== id)})
}

export const requestOpenAgencyKit = (id: string | null) => setState({...state, openKitId: id})

export const useWatchedAgencyKitIds = () => useSyncExternalStore(subscribe, () => state.watchedIds)
export const useOpenAgencyKitRequest = () => useSyncExternalStore(subscribe, () => state.openKitId)
